import React from 'react';
import { FormattedMessage } from 'react-intl';

import S from 'app/features/footer/components/Footer.styled';
import Text from 'app/components/layout/Text.styled';

const CookieConsent = () => (
  <>
    <S.FooterLinkDivider />
    <Text
      as={S.FooterLink}
      size="l"
      type="semibold"
      data-t="footer-cookie-consent"
      onClick={() => window.evidon?.notice?.showOptions()}
    >
      <FormattedMessage id="footer_cookie_consent" />
    </Text>
  </>
);

CookieConsent.displayName = 'Cookie Consent Tool';

export default CookieConsent;
